import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

const Industryusa = () => {
  return (
    <div className="Industry_usa tekrevol_dark_bg  p-100 ">
        <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={5} lg={5} xl={5} xxl={5}>
                        <h2><span>Startup Prototype Development Services </span> Aligned with Your Industry</h2>
                        <p>Our startup prototype service helps you quickly convert your business concept into functional prototypes. Our industry specialists help us deliver highly effective and reliable web and mobile prototypes that lead to better outcomes.</p>
                        <p>With our startup prototype solutions, we help entrepreneurs build a dynamic working model of their product idea that is capable of explaining the concept of the product, its potential, its functionalities, features, and more. Our prototypes are very helpful for further development, evaluation, and refinement.</p>
                        <Link to="/contact"
                                  className="border_btn dark_btn" aria-label="TekRevol Contact">Transform Ideas into Reality</Link>
                    </Col>
                    <Col xs={12} md={4} lg={4} xl={4} xxl={4} className="offset-lg-3 offset-md-3  my-auto">
                        <div className="industry_scroll">
                            <h3>Fintech</h3>
                            <h3>Healthcare</h3>
                            <h3>E-commerce</h3>
                            <h3>Real Estate</h3>
                            <h3>Automotive</h3>
                            <h3>On-Demand</h3>
                            <h3>Education</h3>
                            <h3>Music</h3>
                            <h3>IT Staff Augmentation</h3>
                            <h3>Logistics</h3>
                            <h3>Retail</h3> 
                        </div>
                    </Col>
                </Row>
            </Container>
    </div>
  )
}

export default Industryusa